import {AnimationSoundPlayer} from "../components/animation/animationSoundPlayer";
import {Position} from "../components/transform/position";
import {TensionSound} from "../components/inputObject/tensionSound";
import {AudioSource} from "../components/audio/audioSource";
import {ImageRenderer} from "../components/image/imageRenderer";
import {AnimationPlayer} from "../components/animation/animationPlayer";
import {Input} from "../components/state/input";
import {Vector2} from "../engine/utils/Vector2";
import {SceneStateManager} from "../components/state/sceneStateManager";
import {AppState} from "../app";
import {createPump} from "../instantiation";
import {PumpToInput} from "../components/state/pumpToInput";
import {settings} from "../settings";


export function initScene(global: AppState) {

    const {entities} = global

    const {canvas, camera} = global.interactiveCanvas;
    const pos = new Vector2(0, 0)

    const mainAnim = entities.create(
        new AnimationPlayer({
            animation: 'clap1'
        }),
        new ImageRenderer(),
        new AnimationSoundPlayer(),
        new SceneStateManager({
            animationId: settings.start,
            animations: [
                {
                    mainAnimation: "clap1",
                    transitionInAnimation: "clap1+3-transition-backwards",
                    transitionOutAnimation: "clap1+3-transition",
                    releaseFrameId: 263
                },
                {
                    mainAnimation: "clap2",
                    transitionInAnimation: "clap2-transition-backwards",
                    transitionOutAnimation: "clap2-transition",
                    releaseFrameId: 270
                },
                {
                    mainAnimation: "clap3",
                    transitionInAnimation: "clap1+3-transition-backwards",
                    transitionOutAnimation: "clap1+3-transition",
                    releaseFrameId: 271
                },
                {
                    mainAnimation: "clap4",
                    transitionInAnimation: "clap4-transition-backwards",
                    transitionOutAnimation: "clap4-transition",
                    releaseFrameId: 270
                },
                {
                    mainAnimation: ["clap5-1", "clap5-2", "clap5-3", "clap5-4", "clap5-5"],
                    transitionInAnimation: "clap5-transition-backwards",
                    transitionOutAnimation: "clap5-transition",
                    releaseFrameId: [60, 121, 150, 167, 240],
                    maxLoopCount: 0
                },
                {
                    mainAnimation: "clap6",
                    transitionInAnimation: "clap6-transition-start",
                    transitionOutAnimation: "clap6-transition-end",
                    releaseFrameId: 169,
                    maxLoopCount: 0,
                    showTransitionOnLoop: true
                }],
        }),
        new Input(),
        new TensionSound(),
        new Position(0, 55)
    )

    const pump1 = createPump(entities, pos.add(new Vector2(-105, -65)))
    entities.addComponent(mainAnim, new PumpToInput({
        pumpEntity: pump1,
    }))

    // const crank = createCrank(entities, pos.add(new Vector2(105, -165)))
    // entities.addComponent(mainAnim, new CrankToInput({
    //     crankEntity:crank
    // }))
    entities.create(new AudioSource({
        soundId: "room"
    }))

}
